// extracted by mini-css-extract-plugin
export default {"initial":"InitialNode_initial__8sZyf"};